import {TranslateService} from '@ngx-translate/core';

export enum UserStatus {
  REQUESTACESS = 0,
  REQUEST_REJECTED = 1,
  REGISTERED,
  CARE_GROUP_ASSIGNED,
  INVITATION_SMS_SENT,
  APP_INSTALLED,
  VERFICATION_DECLINED,
  VERIFICATION_ACCEPTED,
  TERMS_CONDITIONS_DECLINED,
  TERMS_CONDITIONS_ACCEPTED,
  ACTIVE,
  REQUEST_FOR_DEACTIVATION,
  DEACTIVATED,
  INACTIVE,
}

export const userStatusTypesMap = (translate: TranslateService) => {
  return {
    [UserStatus.REQUEST_REJECTED]: {
      id: UserStatus.REQUEST_REJECTED,
      name: translate.instant('UserStatus.REQUEST_REJECTED'),
      status: 'danger',
    },
    [UserStatus.REQUESTACESS]: {
      id: UserStatus.REQUESTACESS,
      name: translate.instant('UserStatus.REQUESTACESS'),
      status: 'warning',
    },
    [UserStatus.REGISTERED]: {
      id: UserStatus.REGISTERED,
      name: translate.instant('UserStatus.REGISTERED'),
      status: 'warning',
    },
   
    [UserStatus.INVITATION_SMS_SENT]: {
      id: UserStatus.INVITATION_SMS_SENT,
      name: translate.instant('UserStatus.INVITATION_SMS_SENT'),
      status: 'warning',
    },
    [UserStatus.APP_INSTALLED]: {
      id: UserStatus.APP_INSTALLED,
      name: translate.instant('UserStatus.APP_INSTALLED'),
      status: 'warning',
    },
    [UserStatus.VERFICATION_DECLINED]: {
      id: UserStatus.VERFICATION_DECLINED,
      name: translate.instant('UserStatus.VERFICATION_DECLINED'),
      status: 'danger',
    },
    [UserStatus.VERIFICATION_ACCEPTED]: {
      id: UserStatus.VERIFICATION_ACCEPTED,
      name: translate.instant('UserStatus.VERIFICATION_ACCEPTED'),
      status: 'warning',
    },
    
    [UserStatus.ACTIVE]: {
      id: UserStatus.ACTIVE,
      name: translate.instant('UserStatus.ACTIVE'),
      status: 'success',
    },
    [UserStatus.INACTIVE]: {
      id: UserStatus.INACTIVE,
      name: translate.instant('UserStatus.INACTIVE'),
      status: 'dormant',
    },
    [UserStatus.REQUEST_FOR_DEACTIVATION]: {
      id: UserStatus.REQUEST_FOR_DEACTIVATION,
      name: translate.instant('UserStatus.REQUEST_FOR_DEACTIVATION'),
      status: 'danger',
    },
    [UserStatus.DEACTIVATED]: {
      id: UserStatus.DEACTIVATED,
      name: translate.instant('UserStatus.DEACTIVATED'),
      status: 'danger',
    },
  };
};
